import useVault from '@/application/read/vaults/useVault';
import { useNetwork } from '@/presentation/context/network';
import { Zero, estimatePremiumPrice } from 'nftx.js';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import AssetCard from './AssetCard';

interface AuctionAssetCardContainerProps {
  vaultId?: string;
  tokenId: string;
  quantity: bigint;
  media: ReactNode;
  onClick: () => void;
  price?: bigint;
  disabled?: boolean;
  selected?: boolean;
  dateAdded?: number;
  shadow?: boolean;
  start: number;
  expires: number;
  onDetailsClick: () => void;
  rarity?: number;
  rarityPercentage: number;
  rarityRank?: number;
  is1155: boolean;
  selectedQuantity: number;
  onQuantityChange: (quantity: number) => void;
}

const AuctionAssetCardContainer = ({
  vaultId,
  tokenId,
  dateAdded,
  start,
  expires,
  ...props
}: AuctionAssetCardContainerProps) => {
  const { data: vault } = useVault({ vaultId });
  const { network } = useNetwork();
  const basePrice = vault?.prices[0].redeem.price;
  const [premiumPrice, setPremiumPrice] = useState(Zero);

  useEffect(() => {
    const h = setInterval(() => {
      if (!vault || !dateAdded) {
        return;
      }
      const now = Math.floor(Date.now() / 1000);
      const [, premiumPrice] = estimatePremiumPrice({
        vTokenToEth: vault.vTokenToEth,
        now,
        holding: { dateAdded },
        network,
      });

      setPremiumPrice(premiumPrice);
    }, 1000);

    return () => clearInterval(h);
  }, [dateAdded, vault, network]);

  const price = useMemo(() => {
    if (!basePrice) {
      return;
    }

    return basePrice + premiumPrice;
  }, [basePrice, premiumPrice]);

  return (
    <AssetCard
      tokenId={tokenId}
      start={start}
      expires={expires}
      price={price}
      isAuction={true}
      {...props}
    />
  );
};

export default AuctionAssetCardContainer;
